import EmptyData from "core/components/EmptyData";
import PageHeader from "core/components/Header/PageHeader";
import NumericTimeAgoWithUnit from "core/components/TimeAgo/NumericTimeAgoWithUnit";
import { _t } from "core/language";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import SkeletonNotification from "../components/SkeletonNotification";
import {
  useGetBadgeNotification,
  useGetNotification,
  useReadNotification,
} from "../hooks/notification";
import { TEMPLATE_ENUM, type Notification } from "../store/types";
import { useCustomNavigate } from "core/utils/helper";
import { RouterName } from "core/router";

const NotificationList = () => {
  const navigate = useCustomNavigate();
  const { loading, data, loadMore, lastPage, params } = useGetNotification();
  const [emptyData, setEmptyData] = useState(false);
  const readNotification = useReadNotification();
  const { fetchBadgeNotification } = useGetBadgeNotification();
  useEffect(() => {
    if (!data?.length && !loading && params?.page === 1) {
      setEmptyData(true);
    } else {
      setEmptyData(false);
    }
  }, [data]);
  const handleFetchMore = () => {
    if (lastPage > params?.page) {
      loadMore();
    }
  };

  const readAll = () => {
    readNotification({
      ids: [],
    });
    fetchBadgeNotification();
  };

  const handleClickItem = (item: Notification) => {
    if (item?.histories[0]?.read_status === "N") {
      readNotification({
        ids: [item.histories[0].id],
      });
      fetchBadgeNotification();
    }
    if (item.template === TEMPLATE_ENUM.ACTION_DAILY_MEAL_SUGGESTION) {
      // navigate to recipe suggestion with request_id
      navigate(
        `${RouterName.INGREDIENT_RECIPES}?request=${item.data.request_id}`
      );
    }
  };

  const rightAction = (
    <div className="" onClick={() => readAll()}>
      <span className="text-[13px] text-[#333333]">{_t("menu.readAll")}</span>
    </div>
  );

  const renderItem = (data: any) => {
    return (data?.length ? data : [])?.map((item: any, key: number) => {
      const isRead =
        item?.histories[0]?.read_status === "Y" ? "text-[#999999]" : "";
      return (
        <div
          key={key}
          className="border-b-[1px] border-b-[#EEEEEE] py-3"
          onClick={() => handleClickItem(item)}
        >
          <h2 className={`text-[#111111] text-[13px] font-medium ${isRead}`}>
            {item.title}
          </h2>
          <p className={`text-[13px] text-[#333333] ${isRead}`}>
            {item?.content}
          </p>
          <span className={`text-[11px] text-[#777777] ${isRead}`}>
            <NumericTimeAgoWithUnit
              createdAt={item.created_at}
              locale={(window as any)._APP_LANG}
            />
          </span>
        </div>
      );
    });
  };

  return (
    <AppLayout>
      <PageHeader
        title={_t("menu.notification_history")}
        sticky
        showCart={false}
        rightAction={rightAction}
      />

      <div>
        <div className="p-4">
          <InfiniteScroll
            dataLength={data?.length || 0}
            next={handleFetchMore}
            hasMore={!!data?.length}
            loader={null}
            className=""
          >
            {renderItem(data)}
          </InfiniteScroll>
          {loading && params?.page > 1 && <SkeletonNotification />}
          {!data?.length && loading ? (
            <div className="">
              {Array.from(Array(params?.page === 1 ? 10 : 4).keys()).map(
                (e: number) => (
                  <SkeletonNotification key={e} />
                )
              )}
            </div>
          ) : !data?.length && !loading && emptyData ? (
            <EmptyData message={_t("menu.no_notification")} />
          ) : null}
        </div>
      </div>
      <BottomNavigation activeIndex={2} />
    </AppLayout>
  );
};

export default NotificationList;
